<template>
  <div class="card mb-0 border-0 shadow-0">
    <div class="card-body text-center py-5 mb-5">
      <div class="mt-5 mb-3">
        <h1 class="display-1 fw-bold" style="color: #E67E22; letter-spacing: 5px;">
            404
        </h1>
      </div>
      <h1 class="error-page-title">{{$t('Page Not Found!')}}</h1>
      <div class="error-page-text">
        {{$t('We’re sorry, the page you requested could not be found. Please go back')}}<br>
        {{$t('to the homepage')}}
        <br><br>
      </div>
      <div class="mt-4">
        <button @click="$router.push({ name: 'dashboards' })" class="btn btn-lg btn-primary"><i class="fas fa-arrow-alt-circle-left me-2"></i>{{$t('Go Back')}}</button>
      </div>
    </div>
</div>
</template>